import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UserType } from '../api';

const useUserTypeOptions = () => {
    const { t } = useTranslation(['common']);

    return useMemo(
        () => [
            { value: UserType.Admin, label: t('common:userTypes.admin') },
            { value: UserType.Dealer, label: t('common:userTypes.dealer') },
            { value: UserType.Purchaser, label: t('common:userTypes.purchaser') },
            { value: UserType.SaleConsultant, label: t('common:userTypes.salesConsultant') },
            { value: UserType.SalesManager, label: t('common:userTypes.salesManager') },
        ],
        [t]
    );
};

export default useUserTypeOptions;
